module.exports = __webpack_public_path__ + "static/media/Yuppie.0e4db32c.jpg";